import { render, staticRenderFns } from "./EditBtn.vue?vue&type=template&id=bd17daf6&scoped=true&"
import script from "./EditBtn.vue?vue&type=script&lang=js&"
export * from "./EditBtn.vue?vue&type=script&lang=js&"
import style0 from "./EditBtn.vue?vue&type=style&index=0&id=bd17daf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd17daf6",
  null
  
)

export default component.exports